// PhonicsLt18.js
// 包装组件：Letter Teams L18
// 路由：/phonics/lt18
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt18 } from './phonics/phonics_data_lt18';

function PhonicsLt18() {
  return <PhonicsLt letterData={letterDataLt18} />;
}

export default PhonicsLt18;
